import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';
import { REPORT_MODULES } from '../../lib/reportModules';
import { CrmPageToastPortal } from '../notifications/CrmPageToastPortal';
import { PortalWebPushBanner } from '../notifications/PortalWebPushBanner';
import { PortalFloatingShell } from './PortalFloatingShell';
import { PortalPresenceReporter } from './PortalPresenceReporter';
import '../../styles/dem-theme-lab.css';

export function ReportAppShell() {
  const { basePath } = usePortal();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('has-dock');
    root.style.removeProperty('--dock-clearance');
    root.style.removeProperty('--mobile-header-clearance');
    root.style.setProperty('--dock-clearance', '0px');
    root.style.setProperty('--mobile-header-clearance', '0px');
    return () => {
      root.style.removeProperty('--dock-clearance');
      root.style.removeProperty('--mobile-header-clearance');
    };
  }, []);

  const home = basePath || '/report';

  const nav = useMemo(
    () => [
      {
        to: home,
        label: 'Home',
        icon: '🏠',
        end: true,
      },
      ...REPORT_MODULES.map((mod) => ({
        to: basePath ? `${basePath}/${mod.slug}` : `/${mod.slug}`,
        label: mod.label,
        icon: mod.icon,
      })),
      {
        to: basePath ? `${basePath}/open-po` : '/open-po',
        label: 'Open PO',
        icon: '🚚',
      },
    ],
    [basePath, home],
  );

  return (
    <div className="app-shell app-shell--dock app-shell--forms app-shell--report app-shell--dem-theme-lab">
      <PortalPresenceReporter portal="report" />
      <div className="main">
        <PortalWebPushBanner variant="toast" />
        <div className="page">
          <PortalFloatingShell portalName="Report" portalKind="report" items={nav}>
            <Outlet />
          </PortalFloatingShell>
        </div>
      </div>
      <CrmPageToastPortal />
    </div>
  );
}
